import { ArrowUpRight, X } from "lucide-react";

export default function Lightbox({ item, onClose }) {
  if (!item) return null;
  return (
    <div
      className="fixed inset-0 z-[100] bg-[#0A0A0A]/92 backdrop-blur-sm overflow-auto p-4 md:p-10"
      onClick={onClose}
      data-testid="lightbox"
    >
      <button
        type="button"
        onClick={onClose}
        className="fixed top-4 right-4 z-[101] w-11 h-11 flex items-center justify-center bg-white border border-[#0A0A0A] hover:bg-[#4C1D95] hover:text-white transition-colors"
        data-testid="lightbox-close"
        aria-label="Close"
      >
        <X size={20} strokeWidth={1.5} />
      </button>
      <figure
        className={`mx-auto ${item.figma ? "max-w-6xl w-full" : "max-w-4xl"}`}
        onClick={(e) => e.stopPropagation()}
      >
        {item.figma ? (
          <>
            <iframe
              title={item.label || "Design"}
              src={item.figma}
              loading="lazy"
              allowFullScreen
              className="w-full h-[82vh] border border-white bg-white block"
              data-testid="lightbox-figma"
            />
            <a
              href={item.figmaLink || item.figma}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1 label-mono text-[#DDD6FE] hover:text-white transition-colors mt-3"
              data-testid="lightbox-figma-link"
            >
              Can't see the design? Open in Figma{" "}
              <ArrowUpRight size={14} strokeWidth={1.5} />
            </a>
          </>
        ) : (
          <img
            src={item.src}
            alt={item.alt}
            className="w-full h-auto border border-white bg-white block"
            data-testid="lightbox-image"
          />
        )}
        {(item.label || item.caption) && (
          <figcaption className="text-sm text-[#DDD6FE] leading-relaxed mt-4 font-mono-ibm">
            {item.label ? `${item.label} — ` : ""}
            {item.caption}
          </figcaption>
        )}
      </figure>
    </div>
  );
}
